import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class AppTokenHandler {
  public access_token_key = 'access_token';
  access_token_value = '';
  loginUserInfo: UserInfo;
  roleList: string[];
  private isAuthenticated = new BehaviorSubject<boolean>(false);

  getSessionToken() {
    if (sessionStorage.length > 0) {
      this.access_token_value = sessionStorage.getItem(this.access_token_key);
    }
    if (this.access_token_value == null) {
      this.access_token_value = '';
    }
    return this.access_token_value;
  }

  setSessionToken(loginData) {
    this.access_token_value = loginData.access_token;
    sessionStorage.setItem(this.access_token_key, this.access_token_value);
    sessionStorage.setItem('UserInfo', JSON.stringify(loginData));
    this.isAuthenticated.next(true);
  }

  getSessionForMenu() {
    if (localStorage.length > 0) {
      var objMenuList = JSON.parse(localStorage.getItem('menuList'));
      return objMenuList;
    }
    else {
      return null;
    }

  }

  setSessionForMenu(menuList) {
    localStorage.setItem('menuList', JSON.stringify(menuList));
  }

  clearSessionToken() {
    this.access_token_value = '';
    sessionStorage.removeItem('UserInfo');
    sessionStorage.removeItem(this.access_token_key);
    sessionStorage.clear();
    localStorage.removeItem('menuList');
    localStorage.clear();
  }

  getLoginUserInfo() {
    this.loginUserInfo = JSON.parse(sessionStorage.getItem('UserInfo'));
    return this.loginUserInfo;

    //     if (sessionStorage.getItem('UserInfo') != null && sessionStorage.getItem('UserInfo') != '') {
    //         let info : any;            
    //        info  = sessionStorage.getItem('UserInfo');
    //        this.loginUserInfo = JSON.parse(window.atob(info));
    //    }
    //  return this.loginUserInfo;
  }

  IsInRole(roles: string[]): boolean {
    const userInfo = this.getLoginUserInfo();
    if (!userInfo || !userInfo.Roles) {
      return false;
    }
    const userRoles = userInfo.Roles.split(',');
    return roles.some((role) => userRoles.includes(role));
  }

  GetRolesList = (): any => {
    const loginInfo: UserInfo = this.getLoginUserInfo();
    this.roleList = loginInfo.Roles.split(',');
    return this.roleList;
  }

  get isLoggedIn() {
    const loginInfo: UserInfo = this.getLoginUserInfo();
    if (loginInfo && loginInfo.IsAuthenticated) {
      this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
    return this.isAuthenticated.value;
  }

}

@Injectable()
export class UserInfo {
  UserId: string;
  EmpGPN: string;
  EmpEmail: string;
  EmpName: string;
  IssuedUtc: Date;
  ExpiresUtc: Date;
  Roles: string;
  UserImage: string;
  access_token: string;
  IsConsent: boolean;
  IsLogAppInsights: boolean;
  IsAuthenticated: boolean;
  EmpOfficePhone: string;
  EmpOffDescription: string;
}

@Injectable()
export class HTTPStatus {
  private requestInFlight$: BehaviorSubject<boolean>;
  constructor() {
    this.requestInFlight$ = new BehaviorSubject(false);
  }

  setHttpStatus(inFlight: boolean) {
    this.requestInFlight$.next(inFlight);
  }

  getHttpStatus(): Observable<boolean> {
    return this.requestInFlight$.asObservable();
  }

}
